import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import { AudioControllerBehavior, MetersController, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";
import { EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class MetersControllerGame extends MetersController {
    /**
     * onReturningFreegameUpdateMeter overrided to update the bottom bar win and
     * base win meter after returning from free game.
     * @param evt 
     */
    protected onReturningFreegameUpdateMeter(evt: any): void {
        super.onReturningFreegameUpdateMeter(evt);
        (ingenuity.parserModel as GameParserModel).setIsFreeSpintriggered(false);
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
        dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, { value: (ingenuity.parserModel as GameParserModel).getFreeSpinTotalWin() + (ingenuity.parserModel as GameParserModel).getBaseGameTotalWin() + (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() });
    }
    protected onStartWinTickUp(evt: any) {
        let winMeter;
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
        (winMeter = this.winValueMeter) === null || winMeter === void 0 ? void 0 : winMeter.startTick(ingenuity.parserModel.getTotalWin(), this.model.getIsCredits(), false, this.model.getWinMeterTickUpDuration(), true, this.updateBalance.bind(this));
            (ingenuity.soundManager as AudioControllerBehavior).playSound(this.model.getWinMeterTickUpSound(), 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
        this.fadeBaseGameBGM();
        if (((ingenuity.soundManager as AudioControllerBehavior).getSoundInstance(SoundConstantGame.CHARACTER_ELF_WIN, SlotConstantsBehavior.SOUND_LIST_PRELOAD) || (ingenuity.soundManager as AudioControllerBehavior).getSoundInstance(SoundConstantGame.CHARACTER_ORC_WIN, SlotConstantsBehavior.SOUND_LIST_PRELOAD))) {
            dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_IN_SOUND, { id: this.model.getWinMeterTickUpSound(), vol: 0.5, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD, });
        }
    }
    /**
    * This method is use to skip cascade animation on stage click
    */
    protected onForceStopWinTickUp(evt?: IEvent): void {
        if (ingenuity.configData.stageClickOnCascade) {
            if (this.winValueMeter.getIsTickUpRunning()) {
                this.winValueMeter.forceStop(this.model.getIsCredits(), false, true);
            }
            dispatcher.fireEvent(eventDispatchers.STAGE_CLICK_ON_CASCADE);
        } else {
            super.onForceStopWinTickUp()
        }
    }
    /**
    * Override to start progress bar
    */
    protected updateBalance(): void {
        if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
            //
        } else {
            if (!this.model.getIsScatterWins()) {
                dispatcher.fireEvent(SlotEventConstants.UPDATE_BALANCE_METER);
            }
            dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_OUT_SOUND, { id: SoundConstant.BASEGAME_BGMLOOP, vol: 1, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
            if (this.model.getIsWin() && !(ingenuity.parserModel as GameParserModel).getIsHoldAndRespinAvailable()) {
                dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
            }
        }
    }

}
